export const JsQuestions = [
  { Ques: "What is a variable?", Ans: "storage" },
  {
    Ques: "What are the three keywords for declaring variables in JavaScript?",
    Ans: "let const var",
  },
  {
    Ques: "Are let and const block-scoped or function-scoped?",
    Ans: "block scoped",
  },
  {
    Ques: "Are var variables block-scoped or function-scoped?",
    Ans: "function scoped",
  },
  {
    Ques: "what are the types of variable scope?",
    Ans: "Global scope and local scope",
  },
  
];
export const PyQuestions = [
  {
    Ques: "What is a variable in Python?",
    Ans: "a named reference to a value",
  },
  {
    Ques: "How do you declare a variable in Python?",
    Ans: "using an assignment statement, e.g., x = 5",
  },
  {
    Ques: "What is the difference between local and global variables in Python?",
    Ans: "Local variables are defined within a function and have a local scope, while global variables are defined outside of any function and have a global scope.",
  },
  {
    Ques: "What is the naming convention for Python variables?",
    Ans: "Variables should be named using lowercase letters and underscores, e.g., my_variable.",
  },
  {
    Ques: "How do you check the data type of a variable in Python?",
    Ans: "using the type() function, e.g., type(x)",
  },
];

export const CQuestions = [
  {
    Ques:"What are used to store values in C Programs",
    Ans:"Variables"
  },
  {
    Ques:"What is a variable in C programming?",
    Ans:"Identifier"
  },
  {
    Ques:"How do you assign a value to a variable in C programming?",
    Ans:"Assignment"
  },
  {
    Ques:"What is the difference between a local and global variable in C programming?",
    Ans:"Scope"
  },
  {
    Ques:"What is the scope of a variable declared inside a block in C programming?",
    Ans:"Block"
  },
  {
    Ques:"What is the scope of a variable declared inside a function in C programming?",
    Ans:"Function"
  },
  {
    Ques:"What is the default scope of a variable in C programming?",
    Ans:"Local"
  }
];

export const Cpp= [
  {
    Ques:"How do you declare a variable in C++ programming?",
    Answer: "Data type"
  },
  {
    Ques:"How do you declare a pointer variable in C++ programming?",
    Ans:"Asterisk"
  },
  {
    Ques:"What is the purpose of using pointers in C++ programming?",
    Ans:"Address"
  },
  {
    Ques:"What is the purpose of using constants in C++ programming?",
    Ans:"Immutable"
  },
  {
    Ques:"How do you declare a constant in C++ programming?",
    Ans:"Const"
  },
  {
    Ques:"What is type casting in C++ programming?",
    Ans:"Conversion"
  }
];

export const Java = [
  {
    Ques:"How to convert a variable from one data type to another",
    Ans:"Typecasting"
  },
  {
    Ques:"How do you declare a constant in Java programming?",
    Ans:"Final"
  },
  {
    Ques:"How Reference variables are declared?",
    Ans:"Class name"
  },
  {
    Ques:"What does a variable contains if it is not initialized",
    Ans:"Default value"
  },
  {
    Ques:"What is the default scope of a variable in Java programming?",
    Ans:"Local"
  }
];


